// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FbXat","colMin":"styles_colMin__2LChY"};